var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRouterImg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55.891,
  height: 55.893,
  viewBox: "0 0 55.891 55.893"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M55.073 41.156h-2.456v-3.548a.82.82 0 0 0-.819-.819h-.819V11.955a2.456 2.456 0 0 0-4.912 0V36.79h-.819a.82.82 0 0 0-.819.819v3.548H11.462v-3.548a.82.82 0 0 0-.819-.819h-.818V11.955a2.456 2.456 0 0 0-4.912 0V36.79h-.819a.82.82 0 0 0-.819.819v3.548H.819a.82.82 0 0 0-.819.819v9.823a.82.82 0 0 0 .819.819h1.2v2.456a.82.82 0 0 0 .819.819h50.215a.82.82 0 0 0 .819-.819v-2.456h1.2a.82.82 0 0 0 .819-.819v-9.825a.82.82 0 0 0-.819-.819ZM47.7 11.955a.819.819 0 0 1 1.637 0V36.79H47.7Zm-1.637 26.472h4.912v2.729h-4.908ZM6.55 11.955a.819.819 0 0 1 1.637 0V36.79H6.55ZM4.912 38.427h4.913v2.729H4.912Zm47.322 15.829H3.657v-1.637h48.577Zm2.02-3.275H1.637v-8.187h52.617Z",
  "data-name": "Path 872"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M4.093 49.343h24.016a.82.82 0 0 0 .819-.819v-3.275a.82.82 0 0 0-.819-.819H4.093a.82.82 0 0 0-.819.819v3.275a.82.82 0 0 0 .819.819m.819-3.275H27.29v1.637H4.911Z",
  "data-name": "Path 873"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M45.249 49.343h6.55a.82.82 0 0 0 .819-.819v-3.275a.82.82 0 0 0-.819-.819h-6.55a.82.82 0 0 0-.819.819v3.275a.82.82 0 0 0 .819.819m.819-3.275h4.912v1.637h-4.912Z",
  "data-name": "Path 874"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M34.332 49.343h6.55a.82.82 0 0 0 .819-.819v-3.275a.82.82 0 0 0-.819-.819h-6.55a.82.82 0 0 0-.819.819v3.275a.82.82 0 0 0 .819.819m.819-3.275h4.912v1.637h-4.912Z",
  "data-name": "Path 875"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M40.963 1.995a6.8 6.8 0 0 0-4.97-1.992.819.819 0 1 0 .031 1.637 5.165 5.165 0 0 1 5.3 5.3.82.82 0 0 0 .8.833h.012a.82.82 0 0 0 .819-.806 6.8 6.8 0 0 0-1.992-4.969Z",
  "data-name": "Path 876"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M35.511 3.058a.819.819 0 1 0 .153 1.63 2.28 2.28 0 0 1 2.611 2.611.82.82 0 0 0 .738.89h.078a.82.82 0 0 0 .814-.742 3.9 3.9 0 0 0-4.394-4.388Z",
  "data-name": "Path 877"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M19.869 1.639a.819.819 0 0 0 .027-1.637 6.8 6.8 0 0 0-6.961 6.961.82.82 0 0 0 .819.806h.014a.82.82 0 0 0 .8-.833 5.164 5.164 0 0 1 5.3-5.3Z",
  "data-name": "Path 878"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M20.228 4.683a.819.819 0 1 0 .153-1.624 3.91 3.91 0 0 0-4.394 4.388.82.82 0 0 0 .814.742h.078a.82.82 0 0 0 .738-.892 2.285 2.285 0 0 1 2.611-2.614",
  "data-name": "Path 879"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M18.394 27.022a.82.82 0 0 0 .819.819h17.466a.82.82 0 0 0 .819-.819v-10.1H18.394Zm9.006-7.914h1.094a2.456 2.456 0 1 1 0 4.912h-1.092a2.456 2.456 0 0 1 0-4.912Z",
  "data-name": "Path 880"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M27.4 22.38h1.092a.819.819 0 1 0 0-1.637H27.4a.819.819 0 1 0 0 1.637",
  "data-name": "Path 881"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M23.306 10.645a4.64 4.64 0 0 1 9.279 0v4.639h1.637v-4.639a6.277 6.277 0 1 0-12.554 0v4.639h1.637Z",
  "data-name": "Path 882"
})));
export default SvgRouterImg;